import { styled } from '@lichtblick/styled';
import { BorderRadius, Colors, Spacing } from '@lichtblick/theme';

export const CheckboxContainer = styled.div`
  position: relative;
  align-items: center;
  display: flex;
  gap: ${Spacing.Xxs};
`;

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  cursor: pointer;
  height: 1.5rem;
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  width: 1.5rem;
`;

export const StyledCheckbox = styled.div<{ $isChecked: boolean }>`
  align-items: center;
  background-color: ${({ $isChecked }) => ($isChecked ? Colors.blue[100] : Colors.blue[5])};
  border: 1px solid ${({ $isChecked }) => ($isChecked ? Colors.blue[100] : Colors.blue[20])};
  border-radius: ${BorderRadius.Xs};
  display: flex;
  height: 1.5rem;
  justify-content: center;
  margin-right: ${Spacing['3Xs']};
  min-width: 1.5rem;
  transition: all 0.3s;

  &:hover {
    border-color: ${Colors.blue[100]};
  }

  svg {
    color: ${({ $isChecked }) => ($isChecked ? '#fff' : 'transparent')};
  }
`;
